<template>
  <div class="promotion-goods">
    <div class="title">限时促销</div>
    <div class="promotion-goods-main">
      <div class="promotion-head">
        <p :class="status===1?'active':''" @click="changeStatus(1)">正在促销</p>
        <p :class="status===2?'active':''" @click="changeStatus(2)">促销预告</p>
      </div>
      <div class="promotion-now-container" v-if="status===1">
        <div class="promotion-now" v-for="(value,index) in promotionData" :key="index">
          <div class="img" @click="toProduct(value.goodsId)">
            <img :src="value.img" alt />
          </div>
          <p class="name" @click="toProduct(value.goodsId)">{{value.goodsName}}</p>
          <div class="price-cart">
            <p class="price" v-if="value.promotionReduce>0">
              <span class="promotion-price">￥{{value.newPrice}}</span>
              <span class="old-price">￥{{value.price}}</span>
            </p>
            <p class="price" v-else>
              <span class="promotion-price">￥{{value.price}}</span>
            </p>
          </div>
        </div>
        <div v-if="promotionData.length===0" class="nothing">
          <img class="img" src="../../../assets/xb-images/promotion-nothing.png" alt />
          <p>先喝杯茶休息一下吧</p>
        </div>
      </div>
      <div class="promotion-notice-container" v-if="status===2">
        <div class="promotion-notice" v-for="(value,index) in promotionNoticeData" :key="index">
          <div class="img" @click="toProduct(value.goodsId)">
            <img :src="value.img" alt />
          </div>
          <p class="name" @click="toProduct(value.goodsId)">{{value.goodsName}}</p>
          <div class="price-time">
            <p class="price">￥{{value.price}}</p>
            <p class="time">{{value.time}} 开启</p>
          </div>
        </div>
        <div v-if="promotionNoticeData.length===0" class="nothing">
          <img class="img" src="../../../assets/xb-images/promotion-nothing.png" alt />
          <p>先喝杯茶休息一下吧</p>
        </div>
      </div>
      <div class="pagination-tpl-container" v-if="status===1">
        <pagination-tpl
          :total="total1"
          :pageSize="pageSize1"
          :currentPage="currentPage1"
          @queryChange="onQueryChangePromotion"
        ></pagination-tpl>
      </div>
      <div class="pagination-tpl-container" v-if="status===2">
        <pagination-tpl
          :total="total2"
          :pageSize="pageSize2"
          :currentPage="currentPage2"
          @queryChange="onQueryChangePromotionNotice"
        ></pagination-tpl>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationTpl from "base/PaginationTpl";
import XBPromotion from "models/xb/promotion.js";
import ShoppingCart from "models/xb/shopping-cart.js";
const xbPromotion = new XBPromotion();
const shoppingCart = new ShoppingCart();
export default {
  components: {
    PaginationTpl
  },
  data() {
    return {
      status: 1,
      promotionData: [],
      currentPage1: 1,
      pageSize1: 20,
      total1: 0,
      promotionNoticeData: [],
      currentPage2: 1,
      pageSize2: 20,
      total2: 0,
      carDate: 0 // 触发购物车
    };
  },
  created() {
    this.getPromotionList();
  },
  methods: {
    changeStatus(status) {
      this.status = status;
      if (status === 2 && this.promotionNoticeData.length === 0) {
        this.getPromotionNoticeList();
      }
    },
    // 获取促销列表
    getPromotionList() {
      let currentPage = this.currentPage1;
      xbPromotion.getPromotionList(currentPage).then(res => {
        if (res.success) {
          let arr = [];
          this.total1 = res.result.totalNum;
          this.pageSize1 = res.result.pageSize;
          res.result.items.map(value => {
            let obj = {};
            obj.goodsId = value.goodsId;
            obj.goodsName = value.goodsName;
            obj.price = value.marketPrice;
            obj.promotionReduce = value.promotionReduce;
            let newPrice = Number(value.marketPrice) - Number(value.promotionReduce)
            obj.newPrice = Math.round(newPrice * 100) / 100
            obj.img = value.itemImages[0]
              ? value.itemImages
              : "http://image.8844it.com/ydb2/goodDefault.png";
            arr.push(obj);
          });
          this.promotionData = arr;
        }
      });
    },
    // 获取预促销列表
    getPromotionNoticeList() {
      let currentPage = this.currentPage2;
      xbPromotion.getPromotionNoticeList(currentPage).then(res => {
        if (res.success) {
          let arr = [];
          this.total2 = res.result.totalNum;
          this.pageSize2 = res.result.pageSize;
          res.result.items.map(value => {
            let obj = {};
            obj.goodsId = value.goodsId;
            obj.goodsName = value.goodsName;
            obj.price = value.marketPrice;
            obj.promotionReduce = value.promotionReduce;
            obj.time = this.getTime(value.beginTime);
            obj.img = value.itemImages[0]
              ? value.itemImages
              : "http://image.8844it.com/ydb2/goodDefault.png";
            arr.push(obj);
          });
          this.promotionNoticeData = arr;
        }
      });
    },
    // 翻页
    onQueryChangePromotion(data) {
      this.currentPage1 = data.currentPage;
      this.getPromotionList();
    },
    // 翻页
    onQueryChangePromotionNotice(data) {
      this.currentPage2 = data.currentPage;
      this.getPromotionNoticeList();
    },
    // 商品详情
    toProduct(id) {
      let routeUrl = this.$router.resolve({
        path: "/product",
        query: {
          id: id
        }
      });
      window.open(routeUrl.href, "_blank");
    },
    // 加入购物车
    addCart(goodsId) {
      let data = {
        goodsId
      };
      shoppingCart.postAddShoppingCart(data).then(res => {
        if (res.success) {
          // 添加成功
          this.carDate = new Date().getTime();
          this.$emit("addCart", this.carDate);
          this.$message({
            message: "添加成功！",
            center: true,
            type: "success",
            duration: 1000
          });
        } else {
          // 添加失败
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000
          });
        }
      });
    },
    // 获取时间
    getTime(time) {
      let date = new Date(time);
      let month = date.getMonth() + 1;
      month = month > 9 ? month : "0" + month;
      let detailDate = date.getDate();
      detailDate = detailDate > 9 ? detailDate : "0" + detailDate;
      let hour = date.getHours();
      hour = hour > 9 ? hour : "0" + hour;
      let minute = date.getMinutes();
      minute = minute > 9 ? minute : "0" + minute;
      let second = date.getSeconds();
      second = second > 9 ? second : "0" + second;
      return `${month}月${detailDate}日  ${hour}:${minute}:${second}`;
    }
  }
};
</script>
<style lang='scss' scoped>
.promotion-goods {
  .title {
    height: 100px;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    line-height: 100px;
    color: #333333;
    background: url(../../../assets/promotion-goods/promotion-goods-title.png)
      center no-repeat;
  }
  .promotion-goods-main {
    width: 1200px;
    margin: 0 auto;
    .promotion-head {
      height: 60px;
      background: #fff;
      color: #666666;
      font-size: 20px;
      display: flex;
      margin-bottom: 16px;
      p {
        flex: 1;
        line-height: 60px;
        cursor: pointer;
        text-align: center;
      }
      .active {
        color: #ffffff;
        background: url(../../../assets/promotion-goods/promotion-goods-label.png)
          center no-repeat;
      }
    }
    .promotion-notice-container,
    .promotion-now-container {
      display: flex;
      width: 1210px;
      flex-wrap: wrap;
      min-height: 590px;
      align-items: flex-start;
      .promotion-notice,
      .promotion-now {
        width: 232px;
        height: 285px;
        background: rgba(255, 255, 255, 1);
        margin-right: 10px;
        margin-bottom: 10px;
        box-sizing: border-box;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .img {
          width: 150px;
          height: 150px;
          cursor: pointer;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            max-width: 150px;
            max-height: 150px;
          }
        }
        .name {
          cursor: pointer;
          width: 192px;
          word-wrap: break-word;
          font-size: 14px;
          line-height: 14px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          color: #666666;
          margin-bottom: 16px;
        }
        .price-cart {
          width: 192px;
          height: 54px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .price {
            display: flex;
            align-items: flex-end;
            .promotion-price {
              font-size: 20px;
              color: #df3445;
              margin-right: 12px;
              letter-spacing: -1px;
            }
            .old-price {
              font-size: 14px;
              color: #999999;
              text-decoration: line-through;
            }
          }
          .cart {
            width: 70px;
            height: 26px;
            padding: 0;
            border: 0;
            background: #df3445;
            color: #fff;
            font-size: 12px;
          }
        }
        .price-time {
          width: 232px;
          border-top: 1px solid #f7f7f7;
          height: 53px;
          display: flex;
          flex-direction: column;
          .price {
            margin-top: 5px;
            font-size: 20px;
            color: #df3445;
            padding-left: 20px;
          }
          .time {
            margin-top: 5px;
            font-size: 14px;
            padding-left: 20px;
            color: #999999;
          }
        }
      }
      .nothing {
        width: 1200px;
        height: 500px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        font-size: 16px;
        color: #666666;
        .img {
          margin-bottom: 20px;
        }
      }
    }
    .pagination-tpl-container {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
